import { render, staticRenderFns } from "./DoctorPreview.vue?vue&type=template&id=66a630e4"
import script from "./DoctorPreview.vue?vue&type=script&lang=js"
export * from "./DoctorPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports